import getters from './clientGetters'
import mutations from './clientMutations'
import state from './clientState'
import actions from './clientActions'

export default {
  namespaced: true,
  getters,
  actions,
  state,
  mutations,
}
